export default __webpack_public_path__ + "static/media/sort-down.2d778424.svg";